import script from "./WrongQuestionCartDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrongQuestionCartDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./WrongQuestionCartDrawer.vue?vue&type=style&index=0&id=3882bec8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3882bec8"]])

export default __exports__